export const conditionallyHighlighted = (
  currentPathname: string,
  targetPathname: string
): boolean => currentPathname === targetPathname;
